import React, { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import BgContainer2 from "./CommonC/BgContainer2";
import SelexRiskNavbar from "./CommonC/SelexRiskNavbar";
import { useLocation } from 'react-router-dom';
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, List, ListItem, Paper } from "@mui/material";
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Link } from 'react-router-dom';
import Projectcolors from '../Utils/Colors';
import Chip from "@mui/material/Chip";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";



const drawerWidth = 320;

function SelexRiskHelp(){
    
    const location = useLocation();
    const [activeLink, setActiveLink] = useState('');
    const primary = "#0078c9";
const accent = "#9e0b22";
const navy = "#0f172a";
    const coreInputs = [
  { field: "asset_tag", type: "Text", required: "Required", description: "Unique tag (e.g., V-101).", influence: "Identifier; not used in math." },
  { field: "functional_location", type: "Text", required: "Recommended", description: "SAP functional location / area.", influence: "Context only." },
  { field: "unit_area", type: "Text", required: "Recommended", description: "Process unit/area name.", influence: "Context only." },
  { field: "equipment_type", type: "Text (fixed per sheet)", required: "Required", description: "Must match sheet.", influence: "Routes to correct multipliers." },
  { field: "service_fluid", type: "Text", required: "Recommended", description: "Primary service medium.", influence: "Context; sometimes correlated." },
  { field: "duty_description", type: "Text", required: "Recommended", description: "Short duty summary.", influence: "Context only." },
  { field: "criticality_class", type: "A/B/C or 1–5", required: "Recommended", description: "Site criticality.", influence: "Priority signal; not in PoF math by default." },
  { field: "install_date", type: "YYYY-MM-DD", required: "Optional", description: "Commission date.", influence: "Context only." },
  { field: "last_overhaul_date", type: "YYYY-MM-DD", required: "Recommended", description: "Last major overhaul.", influence: "Context only." },
  { field: "run_hours_to_date", type: "Integer (h)", required: "Recommended", description: "Cumulative hours.", influence: "Reliability analytics (indirect)." },
  { field: "availability_pct", type: "0–100 %", required: "Recommended", description: "Last 12 months availability.", influence: "Lower availability slightly ↑ hazard." },
  { field: "MTBF_days", type: "Number (days)", required: "Preferred", description: "Mean Time Between Failures.", influence: "λ_base = 1/MTBF_days (primary driver)." },
  { field: "MTTR_hours", type: "Number (h)", required: "Optional", description: "Mean Time To Repair.", influence: "Small ↑ hazard as MTTR increases." },
  { field: "PM_compliance_pct", type: "0–100 %", required: "Optional", description: "PM compliance %.", influence: "Lower compliance slightly ↑ hazard." },
  { field: "backlog_workorders", type: "Integer", required: "Optional", description: "Open WO count.", influence: "Not direct." },
  { field: "PM_WO_count_last_12m", type: "Integer", required: "Optional", description: "PM WOs (12m).", influence: "Not direct." },
  { field: "CM_WO_count_last_12m", type: "Integer", required: "Optional", description: "CM WOs (12m).", influence: "Not direct." },
  { field: "EM_WO_count_last_12m", type: "Integer", required: "Optional", description: "EM WOs (12m).", influence: "Not direct." },
  { field: "total_wo_last_12m", type: "Integer", required: "Optional/Derived", description: "Total WOs (12m).", influence: "Not direct." },
  { field: "planned_downtime_hours_last_12m", type: "Number (h)", required: "Optional", description: "Planned downtime.", influence: "Not direct." },
  { field: "unplanned_downtime_hours_last_12m", type: "Number (h)", required: "Recommended", description: "Unplanned downtime.", influence: "Moderate ↑ hazard." },
  { field: "material_cost_last_12m", type: "Number", required: "Optional", description: "Material/spares cost.", influence: "Not used." },
  { field: "labor_hours_last_12m", type: "Number (h)", required: "Optional", description: "Labor hours.", influence: "Not used." },
  { field: "total_failures_life", type: "Integer", required: "Optional", description: "Lifetime failures.", influence: "Not direct." },
  { field: "failures_last_5y", type: "Integer", required: "Optional", description: "≤ 5 years.", influence: "History; indirect." },
  { field: "failures_last_4y", type: "Integer", required: "Optional", description: "≤ 4 years.", influence: "History; indirect." },
  { field: "failures_last_3y", type: "Integer", required: "Recommended (if no MTBF)", description: "≤ 3 years.", influence: "Fallback to estimate λ_base." },
  { field: "failures_last_2y", type: "Integer", required: "Optional", description: "≤ 2 years.", influence: "History; indirect." },
  { field: "failures_last_1y", type: "Integer", required: "Recommended", description: "≤ 1 year.", influence: "Recent → higher hazard." },
  { field: "failures_last_9m", type: "Integer", required: "Recommended", description: "≤ 9 months.", influence: "Recent → higher hazard." },
  { field: "failures_last_6m", type: "Integer", required: "Recommended", description: "≤ 6 months.", influence: "High weight in multipliers." },
  { field: "failures_last_3m", type: "Integer", required: "Recommended", description: "≤ 3 months.", influence: "Highest weight in multipliers." },
  { field: "last_failure_date", type: "YYYY-MM-DD", required: "Optional", description: "Most recent failure.", influence: "Context only." },
  { field: "failure_mode_most_common", type: "Text", required: "Optional", description: "Dominant failure mode.", influence: "Context only." },
  { field: "rpn", type: "Integer", required: "Optional", description: "FMEA RPN.", influence: "Not used by default." },
  { field: "RBI_risk", type: "Enum {H,M,L}", required: "Recommended", description: "RBI category.", influence: "H > M > L in hazard." },
  { field: "last_inspection_date", type: "YYYY-MM-DD", required: "Recommended", description: "Last inspection.", influence: "Context only." },
  { field: "next_inspection_due", type: "YYYY-MM-DD", required: "Recommended", description: "Next inspection.", influence: "Context only." },
  { field: "ndt_methods", type: "Text list", required: "Optional", description: "e.g., UT;RT;MT.", influence: "Context only." },
  { field: "notes", type: "Text", required: "Optional", description: "Free remarks.", influence: "No impact." }
];

const vesselInputs = [
  { field: "PSV_set_pressure_kPag", type: "Number (kPag)", required: "Optional", description: "PSV set pressure.", influence: "Context; not direct." },
  { field: "shell_min_thickness_mm", type: "Number (mm)", required: "Recommended", description: "Minimum measured shell thickness.", influence: "Lower thickness → higher hazard (if near limit)." },
  { field: "corrosion_rate_mm_per_y", type: "Number (mm/y)", required: "Recommended", description: "Estimated/monitored corrosion rate.", influence: "Higher rate → higher hazard." }
];

const columnInputs = [
  { field: "column_dp_kpa", type: "Number (kPa)", required: "Recommended", description: "Column differential pressure at normal rates.", influence: "Higher ΔP → higher hazard." },
  { field: "tray_or_packing", type: "Text", required: "Optional", description: "Internals type.", influence: "Context; not direct." },
  { field: "flooding_indicator_pct", type: "0–100 %", required: "Recommended", description: "Flooding/weeping proximity indicator.", influence: "Higher % → higher hazard." }
];

const heatExchangerInputs = [
  { field: "LMTD_C", type: "Number (°C)", required: "Optional", description: "Log Mean Temperature Difference.", influence: "Context; not direct." },
  { field: "fouling_factor", type: "Number", required: "Recommended", description: "Thermal fouling factor.", influence: "Higher fouling → higher hazard." },
  { field: "tubes_plugged_count", type: "Integer", required: "Recommended", description: "Number of tubes plugged.", influence: "More plugged tubes → higher hazard." }
];

const reactorInputs = [
  { field: "catalyst_activity_index", type: "Number (≈0.6–1.1)", required: "Recommended", description: "Relative catalyst activity (1.0 = nominal).", influence: "Lower activity → higher hazard." },
  { field: "bed_dp_kpa", type: "Number (kPa)", required: "Recommended", description: "Bed differential pressure.", influence: "Higher ΔP (fouling/coking) → higher hazard." },
  { field: "hot_spot_temp_C", type: "Number (°C)", required: "Recommended", description: "Maximum bed hot-spot temperature.", influence: "Higher temperature → higher hazard." }
];

const airCoolerInputs = [
  { field: "fan_vibration_mm_s", type: "Number (mm/s)", required: "Recommended", description: "Overall fan vibration.", influence: "Higher vibration → higher hazard." },
  { field: "motor_current_A", type: "Number (A)", required: "Optional", description: "Motor current draw.", influence: "Context; slight effect if overloaded." },
  { field: "fin_cleanliness_index", type: "0–1", required: "Recommended", description: "Higher = cleaner fins.", influence: "Lower index → higher hazard." }
];

const firedHeaterInputs = [
  { field: "tube_metal_temp_C", type: "Number (°C)", required: "Recommended", description: "Tube metal temperature.", influence: "Higher TMT → higher hazard." },
  { field: "bridgewall_temp_C", type: "Number (°C)", required: "Optional", description: "Bridgewall temperature.", influence: "Context; correlated." },
  { field: "stack_O2_pct", type: "Number (%)", required: "Recommended", description: "Excess oxygen in stack.", influence: "Off-optimal O₂ (too low/high) → higher hazard." }
];

const controlValveInputs = [
  { field: "travel_deviation_pct", type: "Number (%)", required: "Recommended", description: "Travel error vs setpoint.", influence: "Higher deviation/stiction → higher hazard." },
  { field: "hysteresis_pct", type: "Number (%)", required: "Optional", description: "Hysteresis in travel.", influence: "Higher hysteresis → higher hazard (smaller effect)." },
  { field: "leakage_class", type: "Enum {IV,V,VI}", required: "Recommended", description: "Seat leakage class.", influence: "IV worse than V/VI → higher hazard." }
];

const pumpInputs = [
  { field: "vibration_overall_mm_s", type: "Number (mm/s)", required: "Recommended", description: "Overall pump vibration.", influence: "Higher vibration → higher hazard." },
  { field: "seal_leak_rate_lph", type: "Number (L/h)", required: "Recommended", description: "Mechanical seal leakage rate.", influence: "Higher leakage → higher hazard." },
  { field: "flow_m3h", type: "Number (m³/h)", required: "Optional", description: "Operating flow.", influence: "Context; slight effect if far from BEP." }
];

const compressorInputs = [
  { field: "surge_margin_pct", type: "Number (%)", required: "Recommended", description: "Distance to surge.", influence: "Lower margin → higher hazard." },
  { field: "discharge_temp_C", type: "Number (°C)", required: "Recommended", description: "Discharge temperature.", influence: "Higher temperature → higher hazard." },
  { field: "polytropic_eff_pct", type: "Number (%)", required: "Recommended", description: "Polytropic efficiency.", influence: "Lower efficiency → higher hazard." }
];

// -------------------- Reusable Table Component --------------------
function InputTable({ title, data }) {
  return (
    <Box sx={{ mb: 5 }}>
      <Typography sx={{ color: primary, fontWeight: 900, mb: 2 }} variant="h6">
        {title}
      </Typography>

      <Paper
        elevation={0}
        sx={{
          borderRadius: "20px",
          overflow: "hidden",
          border: "1px solid rgba(0,120,201,0.13)",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {["Field", "Type/Format", "Required?", "Description", "Influence on PoF"].map(
                (head) => (
                  <TableCell
                    key={head}
                    sx={{
                      fontSize: 13,
                      fontWeight: 900,
                      color: "#fff",
                      bgcolor: primary,
                    }}
                  >
                    {head}
                  </TableCell>
                )
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((row, idx) => (
              <TableRow
                key={idx}
                sx={{
                  "&:hover": { bgcolor: "rgba(0,120,201,0.04)" },
                }}
              >
                <TableCell sx={{ fontSize: 12 }}>{row.field}</TableCell>
                <TableCell sx={{ fontSize: 12 }}>{row.type}</TableCell>
                <TableCell sx={{ fontSize: 12 }}>{row.required}</TableCell>
                <TableCell sx={{ fontSize: 12 }}>{row.description}</TableCell>
                <TableCell sx={{ fontSize: 12 }}>{row.influence}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}

  
    const links = [
      { text: 'Probability of Failure (PoF): Concept', to: '#pof' },
      { text: 'Using the Excel Template', to: '#excel' },
      { text: 'Core Inputs (all sheets)', to: '#core' },
      { text: 'Equipment-Specific Inputs', to: '#equipment' },
    ];

    useEffect(() => {
        const hash = location.hash;
        setActiveLink(hash);
      }, [location.hash]);
console.log(activeLink)
return (
  <Box
    sx={{
      minHeight: "100vh",
      background:
        "radial-gradient(circle at 8% 10%, rgba(0,120,201,0.08), transparent 28%), radial-gradient(circle at 90% 12%, rgba(158,11,34,0.07), transparent 25%), #fff",
      overflowX: "hidden",
    }}
  >
    <CssBaseline />

    <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")} />

    <Box
      sx={{
        width: "min(1320px, calc(100% - 32px))",
        mx: "auto",
        pt: { xs: 2, md: 3 },
        pb: 6,
      }}
    >
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Chip
          label="Help Center"
          sx={{
            bgcolor: "rgba(158,11,34,0.08)",
            color: accent,
            fontWeight: 900,
            fontSize: 14,
            letterSpacing: 0.5,
            mb: 1.5,
          }}
        />

        <Typography
          sx={{
            fontSize: { xs: 30, md: 46 },
            fontWeight: 950,
            color: primary,
            letterSpacing: "-1.5px",
            mb: 1.5,
          }}
        >
          SelexRISK™ User Guide
        </Typography>

        <Typography
          sx={{
            color: "#64748b",
            maxWidth: 760,
            mx: "auto",
            lineHeight: 1.75,
            fontSize: 15,
          }}
        >
          Learn how to estimate Probability of Failure, use the Excel template,
          prepare core inputs, and understand equipment-specific risk factors.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "310px 1fr" },
          gap: 3,
          alignItems: "start",
        }}
      >
        <Box
          sx={{
            position: { xs: "relative", md: "sticky" },
            top: { md: 105 },
            borderRadius: "30px",
            background: "rgba(255,255,255,0.94)",
            border: "1px solid rgba(0,120,201,0.13)",
            boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
            overflow: "hidden",
            p: 2,
          }}
        >
          <Typography
            sx={{
              px: 1.5,
              py: 1,
              fontSize: 13,
              fontWeight: 950,
              color: accent,
              textTransform: "uppercase",
              letterSpacing: 1,
            }}
          >
            Documentation
          </Typography>

          <List sx={{ display: "grid", gap: 1 }}>
            {links.map((link, index) => {
              const active =
                activeLink === link.to || (activeLink === "" && link.to === "#pof");

              return (
                <ListItemButton
                  key={link.text}
                  component={Link}
                  to={link.to}
                  selected={active}
                  sx={{
                    borderRadius: "18px",
                    px: 2,
                    py: 1.3,
                    border: active
                      ? `1px solid ${primary}`
                      : "1px solid transparent",
                    background: active ? "rgba(0,120,201,0.10)" : "transparent",
                    color: active ? primary : navy,
                    transition: "0.25s",
                    "&:hover": {
                      background: "rgba(0,120,201,0.08)",
                      color: primary,
                    },
                    "&.Mui-selected": {
                      background: "rgba(0,120,201,0.10)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 30,
                      height: 30,
                      mr: 1.5,
                      borderRadius: "11px",
                      display: "grid",
                      placeItems: "center",
                      fontSize: 12,
                      fontWeight: 900,
                      color: active ? "#fff" : primary,
                      background: active
                        ? `linear-gradient(135deg, ${primary}, ${accent})`
                        : "rgba(0,120,201,0.08)",
                    }}
                  >
                    {index + 1}
                  </Box>

                  <ListItemText
                    primary={link.text}
                    primaryTypographyProps={{
                      fontSize: 13,
                      fontWeight: 850,
                      lineHeight: 1.35,
                    }}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Box>

        <Box
          sx={{
            borderRadius: "34px",
            background: "#fff",
            border: "1px solid rgba(0,120,201,0.13)",
            boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
            p: { xs: 2.5, md: 4 },
            minHeight: "70vh",
            overflow: "hidden",
            "& h1, & h2, & h3, & h4": {
              color: primary,
              fontWeight: 900,
            },
            "& p": {
              color: "#475569",
              lineHeight: 1.8,
              fontSize: "14px",
            },
          }}
        >
          {(activeLink === "" || activeLink === "#pof") && (
            <Box>
              <Typography variant="h3" gutterBottom>
                Predictive Maintenance Advisor — Help & Input Data Guide
              </Typography>

              <Typography variant="h5" sx={{ color: primary, mt: 3, mb: 1 }}>
                Purpose
              </Typography>

              <Typography sx={{ fontSize: 14 }}>
                This application estimates Probability of Failure (PoF) and
                documents every input in the Excel template, including formats
                and how each item influences predictions.
              </Typography>

              <Typography variant="h5" sx={{ mt: 3, mb: 1 }}>
                Probability of Failure (PoF): Concept
              </Typography>

              <Typography sx={{ fontSize: 14 }}>
                PoF is the likelihood that an equipment item will experience at
                least one failure/trip within a future window. The app reports
                PoF for ~3 months, ~6 months, and ~9 months.
              </Typography>

              <Typography sx={{ mt: 3, fontSize: 16, fontWeight: 800 }}>
                Model Summary
              </Typography>

              <List>
                <ListItem sx={{ fontSize: 14 }}>
                  • Estimate base daily failure rate λbase from MTBF_days or
                  from failure windows.
                </ListItem>
                <ListItem sx={{ fontSize: 14 }}>
                  • Adjust λbase with global and equipment-specific multipliers.
                </ListItem>
                <ListItem sx={{ fontSize: 14 }}>
                  • Compute PoF(t) = 1 − exp(−λadj × t).
                </ListItem>
              </List>
            </Box>
          )}

          {activeLink === "#excel" && (
            <Box>
              <Typography variant="h4" gutterBottom>
                Using the Excel Template
              </Typography>

              <List>
                <ListItem sx={{ fontSize: 14 }}>
                  • One sheet per class: Vessel, Column, Heat Exchangers,
                  Reactors, Air Cooler, Fired Heaters, Control Valves, Pumps,
                  Compressors.
                </ListItem>
                <ListItem sx={{ fontSize: 14 }}>
                  • One row per equipment. Dates must be ISO YYYY-MM-DD.
                </ListItem>
                <ListItem sx={{ fontSize: 14 }}>
                  • Minimum for predictions: asset_tag, equipment_type,
                  MTBF_days or failures_last_3y, availability_pct, and
                  class-specific indicators.
                </ListItem>
              </List>
            </Box>
          )}

          {activeLink === "#core" && (
            <Box>
              <Typography variant="h4" gutterBottom>
                Core Inputs (all sheets)
              </Typography>

              <InputTable title="Core Inputs" data={coreInputs} />
            </Box>
          )}

          {activeLink === "#equipment" && (
            <Box>
              <Typography variant="h4" gutterBottom>
                Equipment-Specific Inputs
              </Typography>

              <InputTable title="Vessel Inputs" data={vesselInputs} />
              <InputTable title="Column Inputs" data={columnInputs} />
              <InputTable
                title="Heat Exchangers Inputs"
                data={heatExchangerInputs}
              />
              <InputTable title="Reactors Inputs" data={reactorInputs} />
              <InputTable title="Air Cooler Inputs" data={airCoolerInputs} />
              <InputTable title="Fired Heaters Inputs" data={firedHeaterInputs} />
              <InputTable title="Control Valves Inputs" data={controlValveInputs} />
              <InputTable title="Pumps Inputs" data={pumpInputs} />
              <InputTable title="Compressors Inputs" data={compressorInputs} />

              <Typography variant="h4" gutterBottom>
                Disclaimer
              </Typography>

              <Typography sx={{ fontSize: 16 }}>
                Decision-support only; does not replace professional judgment.
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  </Box>
);
}

export default SelexRiskHelp;
